var render = function (_h,_vm) {var _c=_vm._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',_vm._b({staticClass:"preloader",class:_vm.data.staticClass},'div',_vm.data.attrs,false),[_c('div',{staticClass:"preloader__circle"})])])}
var staticRenderFns = []

export { render, staticRenderFns }